import { PLAN_PRO } from '@/constants/userSubscriptionPlans'
import { PERMISSION_TYPE, type PERMISSION_VALUE } from '@/permissions'
import { ROLE_TYPE } from '../permissions'

export enum EXPORT_PERMISSION {
  FILE_FORMATS = 'FILE_FORMATS',
  FIGMA = 'FIGMA',
}

export const getExportPermissionsMatrix = (): Record<
  EXPORT_PERMISSION,
  Record<ROLE_TYPE, PERMISSION_VALUE>
> => {
  return {
    [EXPORT_PERMISSION.FILE_FORMATS]: {
      [ROLE_TYPE.TRIAL_ANONYMOUS]: {
        type: PERMISSION_TYPE.NA_BADGE,
        badge: PLAN_PRO,
      },
      [ROLE_TYPE.TRIAL_LOGGED]: {
        type: PERMISSION_TYPE.NA_BADGE,
        badge: PLAN_PRO,
      },
      [ROLE_TYPE.FREE_ANONYMOUS]: {
        type: PERMISSION_TYPE.NA_BADGE,
        badge: PLAN_PRO,
      },
      [ROLE_TYPE.FREE_LOGGED]: {
        type: PERMISSION_TYPE.NA_BADGE,
        badge: PLAN_PRO,
      },
      [ROLE_TYPE.FREE_PROJECT_MEMBER]: {
        type: PERMISSION_TYPE.NA_BADGE,
        badge: PLAN_PRO,
      },
      [ROLE_TYPE.FREE_OWNER]: {
        type: PERMISSION_TYPE.NA_BADGE,
        badge: PLAN_PRO,
      },
      [ROLE_TYPE.PRO_ANONYMOUS]: { type: PERMISSION_TYPE.YES },
      [ROLE_TYPE.PRO_LOGGED]: { type: PERMISSION_TYPE.YES },
      [ROLE_TYPE.PRO_PROJECT_MEMBER]: { type: PERMISSION_TYPE.YES },
      [ROLE_TYPE.PRO_OWNER]: { type: PERMISSION_TYPE.YES },
      [ROLE_TYPE.TEAM_AGENCY_ANONYMOUS]: { type: PERMISSION_TYPE.YES },
      [ROLE_TYPE.TEAM_AGENCY_LOGGED]: { type: PERMISSION_TYPE.YES },
      [ROLE_TYPE.TEAM_AGENCY_PROJECT_MEMBER]: {
        type: PERMISSION_TYPE.YES,
      },
      [ROLE_TYPE.TEAM_AGENCY_MEMBER]: { type: PERMISSION_TYPE.YES },
      [ROLE_TYPE.TEAM_AGENCY_OWNER]: { type: PERMISSION_TYPE.YES },
    },
    [EXPORT_PERMISSION.FIGMA]: {
      [ROLE_TYPE.TRIAL_ANONYMOUS]: { type: PERMISSION_TYPE.NO },
      [ROLE_TYPE.TRIAL_LOGGED]: { type: PERMISSION_TYPE.NO },
      [ROLE_TYPE.FREE_ANONYMOUS]: { type: PERMISSION_TYPE.NO },
      [ROLE_TYPE.FREE_LOGGED]: { type: PERMISSION_TYPE.NO },
      [ROLE_TYPE.FREE_PROJECT_MEMBER]: { type: PERMISSION_TYPE.NO },
      [ROLE_TYPE.FREE_OWNER]: { type: PERMISSION_TYPE.NO },
      [ROLE_TYPE.PRO_ANONYMOUS]: { type: PERMISSION_TYPE.YES },
      [ROLE_TYPE.PRO_LOGGED]: { type: PERMISSION_TYPE.YES },
      [ROLE_TYPE.PRO_PROJECT_MEMBER]: { type: PERMISSION_TYPE.YES },
      [ROLE_TYPE.PRO_OWNER]: { type: PERMISSION_TYPE.YES },
      [ROLE_TYPE.TEAM_AGENCY_ANONYMOUS]: { type: PERMISSION_TYPE.YES },
      [ROLE_TYPE.TEAM_AGENCY_LOGGED]: { type: PERMISSION_TYPE.YES },
      [ROLE_TYPE.TEAM_AGENCY_PROJECT_MEMBER]: {
        type: PERMISSION_TYPE.YES,
      },
      [ROLE_TYPE.TEAM_AGENCY_MEMBER]: { type: PERMISSION_TYPE.YES },
      [ROLE_TYPE.TEAM_AGENCY_OWNER]: { type: PERMISSION_TYPE.YES },
    },
  }
}
